import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
}

function FAQItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-background-200 rounded-lg overflow-hidden transition-all duration-300">
      <button
        className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100/50 transition-colors duration-200"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-sm font-semibold text-foreground-900 pr-4 font-heading">{question}</span>
        <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}>
          <i className="ri-add-line text-sm"></i>
        </span>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
}

interface FAQProps {
  items: { question: string; answer: string }[];
  className?: string;
}

export default function FAQ({ items, className = '' }: FAQProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className={`space-y-3 ${className}`}>
        {items.map((item, index) => (
          <FAQItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </>
  );
}